import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SWRConfig } from 'swr';

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <SWRConfig value={{
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    errorRetryCount: 3,
  }}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </SWRConfig>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
